import React from "react";

import classes from "./Portrait.module.css"


function Portrait(character) {
  
  return (
    <div className={classes.profile__spheres}>
      <img 
      src={character.character.characterBanner} 
      className={classes.banner}
      alt="banner"
      
      ></img>
      <img
        src={character.character.characterPortrait}
        className={classes.profile__portrait__img}
        alt="portraitimg"
        loading="lazy"
      />
    </div>
  );
}

export default Portrait;
